import styled, { css } from 'styled-components';

import { SizeScaleChangeStatus } from 'types/api/sizeScales.type';

import { pickColor } from 'themes/helpers/pickColor';

const statusColor = (status: SizeScaleChangeStatus) => {
  if (status === 'rejected') return pickColor('deleteRedDark');
  if (status === 'skipped') return pickColor('orange');
  if (status === 'deactivated') return pickColor('deleteRedDark');
  if (status === 'added' || status === 'changed' || status === 'reactivated') {
    return pickColor('greenDark');
  }
  return pickColor('grayLabel');
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 1rem;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 2.4rem;
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 1.4rem;
  color: ${pickColor('grayLabel')};
`;

const Summary = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.6rem;
`;

const Count = styled.span<{ status: SizeScaleChangeStatus }>`
  font-size: 1.4rem;
  font-weight: bold;
  text-transform: capitalize;
  color: ${({ status }) => statusColor(status)};
`;

// the list scrolls, the buttons stay in view
const Groups = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;

const GroupTitle = styled.h3<{ status: SizeScaleChangeStatus }>`
  margin: 1.6rem 0 0.6rem;
  font-size: 1.6rem;
  ${({ status }) => css`
    color: ${statusColor(status)};
  `}
`;

const Rows = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;

  th,
  td {
    padding: 0.4rem 0.8rem;
    text-align: left;
    vertical-align: top;
    border-bottom: 1px solid ${pickColor('grayTertiary')};
  }

  th {
    color: ${pickColor('grayLabel')};
    font-weight: normal;
  }
`;

const Warning = styled.span`
  display: block;
  color: ${pickColor('orange')};
`;

const Deactivations = styled.div`
  padding: 0.8rem 1.2rem;
  font-size: 1.4rem;
  color: ${pickColor('deleteRedDark')};
  border: 1px solid ${pickColor('deleteRedDark')};

  ul {
    margin: 0.6rem 0 0;
    padding-left: 2rem;
  }
`;

const Note = styled.p`
  margin: 1.6rem 0 0;
  font-size: 1.4rem;
  color: ${pickColor('grayLabel')};
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;
`;

export {
  Buttons,
  Container,
  Count,
  Deactivations,
  GroupTitle,
  Groups,
  Note,
  Rows,
  Subtitle,
  Summary,
  Title,
  Warning,
};
